import { Anchor } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { CurrencyInput } from 'ui'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { ApplyLoyaltyOnStatus } from '../shared/ApplyLoyaltyOnStatus'
import { messages } from './messages'

export function NominalLoyaltyEditor(props: SettingsProps) {
  const { state } = props
  const { $t } = useIntl()

  return (
    <>
      <CurrencyInput
        name="value"
        state={state}
        aria-label={$t(messages.editor.ariaLabel)}
        helpText={$t(messages.editor.helpText, {
          a: (content) => (
            <Anchor target="_blank" href={$t(messages.editor.moreInformation)}>
              {content}
            </Anchor>
          ),
        })}
      />
      <ApplyLoyaltyOnStatus name="status" state={state} />
    </>
  )
}
